import { FC } from 'react';
import cn from 'classnames';

import { IStatusProps, TStatusIcon } from './Status.interface';

import './style.scss';

const Status: FC<IStatusProps> = ({ className, icon, customIcon, children }) => (
  <div
    className={cn(
      'status',
      {
        status_red: icon === TStatusIcon.Red,
        status_yellow: icon === TStatusIcon.Yellow,
        status_blue: icon === TStatusIcon.Blue,
        status_purple: icon === TStatusIcon.Purple,
        status_orange: icon === TStatusIcon.Orange,
        status_green: icon === TStatusIcon.Green,
        'status_custom-icon': customIcon,
      },
      className,
    )}
  >
    {customIcon}
    {children}
  </div>
);

export default Status;
